//# of people interested in this product
document.addEventListener("DOMContentLoaded", function () {
  // Generate a random number between 3 and 18
  const randomInterestedCount = Math.floor(Math.random() *  (18 - 3 + 1)) + 3;

  
  // Find the element and update its text
  const interestedText = document.querySelector(".custom-interested-text");
  if (interestedText) {
    interestedText.textContent = `Popular pick: ${randomInterestedCount} people just added this to their cart!`;
  }
});